import "es6-promise/auto";
import Vue from "vue";
import Axios from "axios";
import Common from "../components/common.js";
import CompPager from "../components/paging.vue";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/ko"; // 한글 로케일 추가
import Cleave from "vue-cleave-component";

Vue.component("common", Common);

new Vue({
  el: "#homepage-main",
  data: function() {
    return {
      viewModel: {
        lang: "kr",
        langBaseDTO: {},
        listDj: [],
        listEvent: [],
        listGallery: [],
        listService: [],
      },
       optionsVisible: false,
       langs: ["kr","en","tw", "jp"]
    };
  },
  components: {},
  computed: {},
  watch: {
    "viewModel.lang" : function(newVal){
        this.fnInit();
    }
  },
  mounted: function() {
    console.log("mounted [homepage-main]");
    this.$nextTick(() => {
    $(".rock-podcast-toggle-btn").on("click", function (e) {
      e.stopPropagation();
      $(".rock-podcast-header-parent").toggleClass("rock-podcast-menu-open");
    });

    $(".rock-podcast-header-parent").click(function (e) {
      e.stopPropagation();
    });

    $("body,html").click(function (e) {
      $(".rock-podcast-header-parent").removeClass("rock-podcast-menu-open");
    });
  });
    try {
      this.fnInit();
    } catch (e) {
      console.log(e);
    }
  },
  methods: {
  initIsotope: function() {
    this.$nextTick(() => {
      if (!$('.grid').length) {
        console.log("grid not ready yet");
        return;
      }

      // 이미 초기화된 경우 → 재배치만
      if (window.$grid) {
        console.log("Isotope relayout");
        window.$grid.isotope('reloadItems').isotope('layout');
      } else {
        console.log("Isotope new init");
        window.$grid = $('.grid').isotope({
          itemSelector: '.grid-item',
          layoutMode: 'masonry'
        });
      }
    });
  },

  toggleOptions: function() {
    this.optionsVisible = !this.optionsVisible;

    this.$nextTick(() => {
      if (window.$grid) {
        window.$grid.isotope('layout');
      }
    });
  },

  setLang: function(lang) {
    this.viewModel.lang = lang;
    this.optionsVisible = false;

    this.$nextTick(() => {
      if (window.$grid) {
        window.$grid.isotope('layout');
      }
    });
  },

  fnInit: function() {
    let vm = this;
    console.log(vm.viewModel.lang);
    Axios.post("/lion/lang", { paramLang: vm.viewModel.lang })
      .then(function (response) {
        let rs = response.data;
        vm.viewModel.langBaseDTO = rs.homepageBaseDTO;
        vm.viewModel.listDj = rs.listDj;
        vm.viewModel.listGallery = rs.listGallery;
        vm.viewModel.listEvent = rs.listEvent;
        vm.viewModel.listService = rs.listService;
        // 데이터 로드 → grid 렌더됨 → 그 다음 Isotope 실행
        vm.initIsotope();
      })
      .catch(function (ex) {
        console.log(ex);
      });
  }
  }
});



// WEBPACK FOOTER //
// ./src/homepage/homepage-main-controller.js